var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"display-block self-start text-left",attrs:{"type":"button"},on:{"click":_vm.showModal}},[_vm._t("component"),_vm._v(" "),_c('modal',{ref:_vm.uid,attrs:{"name":_vm.uid,"id":_vm.uid,"classes":_vm.classes,"height":"90%"},on:{"before-close":_vm.beforeClose,"opened":_vm.opened,"closed":_vm.closed}},[_vm._t("modal")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }